import { apiService } from '../services/apiService';

export async function listUsers({ page = 1, limit = 20, search = '', sortBy, sortOrder } = {}) {
  const params = { page, limit };
  if (search) params.search = search;
  if (sortBy) params.sortBy = sortBy;
  if (sortOrder) params.sortOrder = sortOrder;
  const res = await apiService.get('/api/users', { params });
  return res.data;
}

export async function createUser(payload) {
  const res = await apiService.post('/api/users', payload);
  return res.data;
}

export async function deleteUser(id) {
  const res = await apiService.delete(`/api/users/${id}`);
  return res.data;
}

export default {
  listUsers,
  createUser,
  deleteUser
};

// Users controller placeholder

// Controller methods: listUsers, getUser, createUser, updateUser, deleteUser
